import { CallWaiterModal } from 'featureSliced/widgets/Modals/CallWaiterModal'
import {
  OpenModalFuncType,
  useOpenModal,
} from 'featureSliced/shared/hooks/useOpenModal'

export const openCallWaiterModal = (
  openModal: OpenModalFuncType,
  isTableTaken?: boolean
) => {
  openModal({
    id: 'CALL_WAITER_MODAL',
    // title: t('common.notifications'),
    // onClose: handleClose,
    components: [
      ({ closeThisModal }) => (
        <CallWaiterModal
          onDeclineClose={closeThisModal}
          onSuccessClose={closeThisModal}
          isTableTaken={isTableTaken}
        />
      ),
    ],
  })
}

export const useOpenCallWaiterModal = () => {
  const openModal = useOpenModal()
  return (isTableTaken?: boolean) =>
    openCallWaiterModal(openModal, isTableTaken)
}
